import React from "react";
import Register from "./register_form";

export default function ParticularSignup() {
  return (
    <>
      <Register />
    </>
  );
}
